// Voice DNA profile — borrowed from santifer/career-ops's voice-dna.md +
// writing-samples/ pattern. The user pastes 2–3 paragraphs of their actual
// writing (Slack messages, a blog post, an old cover letter) and we attach
// it to every generation prompt as a style anchor so the AI's output
// sounds like the user instead of like generic LLM-prose.

const VOICE_KEY = 'voice_dna_profile';
const VOICE_ENABLED_KEY = 'voice_dna_enabled';

const MAX_SAMPLE_CHARS = 4000;

export const getVoiceProfile = () => {
    try {
        return localStorage.getItem(VOICE_KEY) || '';
    } catch {
        return '';
    }
};

export const setVoiceProfile = (text) => {
    const trimmed = (text || '').slice(0, MAX_SAMPLE_CHARS);
    try {
        if (trimmed) localStorage.setItem(VOICE_KEY, trimmed);
        else localStorage.removeItem(VOICE_KEY);
    } catch {
        // localStorage full or disabled — fail silently, this isn't critical
    }
};

export const isVoiceEnabled = () => {
    try {
        return localStorage.getItem(VOICE_ENABLED_KEY) !== 'false';
    } catch {
        return true;
    }
};

export const setVoiceEnabled = (enabled) => {
    try {
        localStorage.setItem(VOICE_ENABLED_KEY, enabled ? 'true' : 'false');
    } catch { /* ignore */ }
};

// Returns the block to inject into prompts, or '' if no profile / disabled.
export const getVoicePromptBlock = () => {
    if (!isVoiceEnabled()) return '';
    const sample = getVoiceProfile();
    if (!sample || sample.length < 50) return '';
    return `
VOICE STYLE REFERENCE — match the cadence, vocabulary level, and sentence rhythm of these writing samples from the candidate. Do NOT copy phrases verbatim; match the *voice*:
"""
${sample}
"""
`;
};

export const MAX_VOICE_SAMPLE_CHARS = MAX_SAMPLE_CHARS;
